import React from 'react';
import IconBase from './IconBase';

const UploadIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M11.3,18.95h1.5v-5.02l2.05,2.05,1.05-1.05-3.9-3.8-3.85,3.85,1.05,1.05,2.1-2.1v5.02ZM4,22V2h10.52l5.47,5.47v14.53H4ZM13.78,8.15V3.5H5.5v17h13v-12.35h-4.73ZM5.5,3.5v4.65V3.5v17V3.5Z"/>
        </IconBase>
    )
}

export default UploadIcon;